import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navigation } from '../../common';
import { smoothlyMenu } from '../Helpers';

class LeftNav extends Component {

  toggleNavigation(e) {
    e.preventDefault();
    $('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }

  activeRoute(regex) {
    const { pathname } = this.props;
    return regex.test(pathname) ? 'active' : null;
  }

  render() {
    const {
      user,
      account,
    } = this.props;

    const slug = account.slug || '';

    const navItems = (
      <ul className="nav metismenu" id="side-menu" ref="menu">
        <li className={this.activeRoute(/dashboard/)}>
          <Link to={slug ? `/advertiser/home/accounts/${slug}/dashboard` : null}>
            <FontAwesomeIcon icon="tachometer-alt" /> Dashboard
          </Link>
        </li>
        {!user.isCustomdash &&
          <li className={this.activeRoute(/job_inventory/)}>
            <Link to={slug ? `/advertiser/home/accounts/${slug}/job_inventory` : null}>
              <FontAwesomeIcon icon="cubes" /> Job Inventory
            </Link>
          </li>
        }
        {!user.isCustomdash &&
          <li className={this.activeRoute(/campaigns/)}>
            <Link to={slug ? `/advertiser/home/accounts/${slug}/campaigns` : null}>
              <FontAwesomeIcon icon="calendar-alt" /> Campaigns
            </Link>
          </li>
        }
        {!user.isCustomdash &&
          <li className={this.activeRoute(/ads/)}>
            <Link to={slug ? `/advertiser/home/accounts/${slug}/ads` : null}>
              <FontAwesomeIcon icon="bullhorn" /> Ads
            </Link>
          </li>
        }
        {!user.isCustomdash &&
          <li className={this.activeRoute(/invoices/)}>
            <Link to={slug ? `/advertiser/home/accounts/${slug}/invoices` : null}>
              <FontAwesomeIcon icon="sticky-note" /> Invoices
            </Link>
          </li>
        }
        <li className={this.activeRoute(/pixel/)}>
          <Link to={slug ? `/advertiser/home/accounts/${slug}/pixel` : null}>
            <FontAwesomeIcon icon="tag" /> Pixel
          </Link>
        </li>
        <li className={this.activeRoute(/info/) || this.activeRoute(/cards/)}>
          <a href="javascript:void(0);">
            <FontAwesomeIcon icon="cog" /> Account Settings
            <span className="fa arrow" />
          </a>
          <ul className="nav nav-second-level collapse">
            <li className={this.activeRoute(/info/)}>
              <Link to={slug ? `/advertiser/home/accounts/${slug}/info` : null}>
                <span className="nav-label">Account Info</span>
              </Link>
            </li>
            {!user.isCustomdash &&
              <li className={this.activeRoute(/cards/)}>
                <Link to={slug ? `/advertiser/home/accounts/${slug}/cards` : null}>
                  <span className="nav-label">Payment Options</span>
                </Link>
              </li>
            }
          </ul>
        </li>
        <li>
          <a href="https://www.jobadx.com/advertiser/faq" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon='question-circle' /> FAQ
          </a>
        </li>
        <li className={this.activeRoute(/tos/)}>
          <Link to={slug ? `/advertiser/home/accounts/${slug}/tos` : null}>
            <FontAwesomeIcon icon="file-alt" /> Terms Of Service
          </Link>
        </li>
      </ul>
    );

    return (
      <Navigation navItems={navItems} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user } = state;
  const { account, pathname } = ownProps;

  return {
    user: user.data,
    account,
    pathname
  };
};

export default connect(mapStateToProps)(LeftNav);
